import { useHistory, useParams } from "react-router";
import { BreadCrumb, Header } from "@funcional/react-ui";
import { useCreateDiscountRule } from "@pbm/discount-rules/hooks";
import { DiscountRuleForm } from "@pbm/discount-rules/components";
import { useState } from "react";
import { IGraphQLError } from "@common/contracts";

export default function CreateDiscountRulePage() {
  let {
    programCode,
    programFamilyCode,
  }: { programCode: string; programFamilyCode: string } = useParams();
  const [graphQLErrors, setGraphQLErrors] = useState<IGraphQLError[]>([]);
  const { isLoading, isSuccess, mutateAsync } = useCreateDiscountRule();

  const history = useHistory();

  const onSubmit = async (input: any) => {
    try {
      await mutateAsync(
        Object.assign(input, {
          programCode,
          programFamilyCode,
          monthlyLimit: Number(input.monthlyLimit),
          ranges: (input.ranges || []).map((item: any) => ({
            boxesFrom: Number(item.boxesFrom),
            boxesTo: item.boxesTo ? Number(item.boxesTo) : undefined,
            saleDiscountPercentage: Number(item.saleDiscountPercentage),
            daysBetweenSalesInterval: Number(item.daysBetweenSalesInterval),
            daysWithoutSalesTolerance: Number(item.daysWithoutSalesTolerance),
          })),
        })
      );
      return history.push(
        `/pbm/programs/${programCode}/families/${programFamilyCode}`
      );
    } catch (error: any) {
      console.error(error);
      if (error.response.errors) {
        return setGraphQLErrors(error.response.errors || []);
      }
      setGraphQLErrors([
        {
          message:
            "Não foi possível salvar o registro, tente novamente mais tarde.",
        },
      ]);
    }
  };

  return (
    <>
      <Header
        title="Nova Regra de Desconto"
        backTo={`/pbm/programs/${programCode}/families/${programFamilyCode}/discount-rules`}
      >
        <BreadCrumb
          marginBottom={0}
          items={[
            { path: "/pbm/programs", label: "Programas" },
            {
              path: `/pbm/programs/${programCode}`,
              label: programCode,
            },
            {
              path: `/pbm/programs/${programCode}/families`,
              label: "Grupos de Produtos",
            },
            {
              path: `/pbm/programs/${programCode}/families/${programFamilyCode}`,
              label: programFamilyCode,
            },
            {
              path: `/pbm/programs/${programCode}/families/${programFamilyCode}/discount-rules`,
              label: "Regras de Desconto",
            },
            { label: "Nova" },
          ]}
        />
      </Header>

      <DiscountRuleForm
        graphQLErrors={graphQLErrors}
        isLoading={isLoading || isSuccess}
        onSubmit={onSubmit}
      />
    </>
  );
}
